import React, { useState, useEffect } from "react";

import MasterScriptTable from "./MasterScriptTable";
import MasterScriptHeader from "./MasterScriptHeader";
import MasterScriptAdd from "./MasterScriptAdd";
import MasterScriptEdit from "./MasterScriptEdit";
import MasterScriptImport from "./MasterScriptImport";

import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";

import DeleteAlert from "../../../components/ui/DeleteAlert";

import Notification, {
  errorNotify,
  successNotify,
} from "../../../Services/Notification";
import { handleGetOneData } from "../../../utils/handleGetOneData";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const scriptApiURL = `${process.env.REACT_APP_API_URL}api/script`;
const exportScriptApiURL = `${process.env.REACT_APP_API_URL}api/export-script`;
const importScriptApiURL = `${process.env.REACT_APP_API_URL}api/import-script`;

const MasterScript = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [isImport, setIsImport] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState();
  const [globalFilters, setGlobalFilters] = React.useState();
  const [bankData, setBankData] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [dateFilters, setDateFilters] = useState();
  const [isFilter, setIsFilter] = useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();
  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };
  const name = "script";

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
      ? sessionStorage.getItem("subscriberToken")
      : sessionStorage.getItem("token")
      }`,
    "Content-Type": "application/json",
  };

  let { data, loading } = useApiNew(
    scriptApiURL,
    "GET",
    { headers },
    renderKey,
  );

  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  //EDIT
  const handleGetOneScript = (id) => {
    return handleGetOneData(data, id);
  };

  // ADD
  const filterBankData = () => {
    let filterData = data;

    if (dateFilters) {
      if (dateFilters.created_start_date && !dateFilters.created_end_date) {
        filterData = data.filter(
          (item) => item?.created_at >= dateFilters.created_start_date,
        );
      }
      if (!dateFilters.created_start_date && dateFilters.created_end_date) {
        filterData = data.filter(
          (item) => item?.created_at <= dateFilters.created_end_date,
        );
      }
      if (dateFilters.created_start_date && dateFilters.created_end_date) {
        filterData = data.filter(
          (item) =>
            item?.created_at >= dateFilters.created_start_date &&
            item?.created_at <= dateFilters.created_end_date,
        );
      }

      if (dateFilters.updated_start_date && !dateFilters.updated_end_date) {
        filterData = data.filter(
          (item) => item?.updated_at >= dateFilters.updated_start_date,
        );
      }

      if (!dateFilters.updated_start_date && dateFilters.updated_end_date) {
        filterData = data.filter(
          (item) => item?.updated_at <= dateFilters.updated_end_date,
        );
      }

      if (dateFilters.updated_start_date && dateFilters.updated_end_date) {
        filterData = data.filter(
          (item) =>
            item?.updated_at >= dateFilters.updated_start_date &&
            item?.updated_at <= dateFilters.updated_end_date,
        );
      }
      if (dateFilters?.scrip_and_isin) {
        filterData = data?.filter(
          (item) => item?.script_name === null && item?.isin === null,
        );
      }
      if (dateFilters?.scrip_or_isin) {
        filterData = data?.filter(
          (item) => item?.script_name === null || item?.isin === null,
        );
      }
    }
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.isin?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.script_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.nse_symbol
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.nse_series
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.nse_lot
            ?.toString()
            .toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.nse_face_value
            ?.toString()
            .toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.bse_code
            ?.toString()
            .toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.bse_lot
            ?.toString()
            .toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.bse_face_value
            ?.toString()
            .toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.bse_group
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.script_type_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.asset_class_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.vidal_sector_code
            ?.toString()
            .toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setBankData(filterData);
  };

  useEffect(() => {
    filterBankData();
  }, [globalFilters, dateFilters]);

  const filterDataByDate = () => {
    let dateSet = data;
    if (dateFilters.created_start_date || dateFilters.created_end_date) {
      dateSet = dateSet.filter(
        (item) =>
          item?.created_at >= dateFilters.created_start_date &&
          item?.created_at <= dateFilters.created_end_date,
      );
    }

    if (dateFilters.updated_start_date || dateFilters.updated_end_date) {
      dateSet = dateSet.filter(
        (item) =>
          item?.updated_at >= dateFilters.updated_start_date &&
          item?.updated_at <= dateFilters.updated_end_date,
      );
    }

    return dateSet;
  };

  // useEffect(() => {
  //   filterDataByDate();
  // }, [dateFilters]);

  const handleFilterChange = (filters) => {
    setDateFilters(filters);
  };

  const handleAddScript = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(scriptApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify(resData?.message);
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT
  const handleEditScript = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${scriptApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteScript = async () => {
    const deleteAPI = `${scriptApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  // IMPORT
  const handleImportScript = async (formData) => {
    setIsButtonClicked(true);
    setIsLoading(true);
    try {
      const res = await axios.post(importScriptApiURL, formData);
      if (res?.data?.error === true) {
        errorNotify(res?.data?.message);
        setIsLoading(false);
        setIsButtonClicked(false);
      } else {
        successNotify(res?.data?.message);
        setIsButtonClicked(false);
        setIsImport(false);
        setIsLoading(false);
        triggerRerender();
      }
      return res.data;
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }

  };

  // DOWNLOAD
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportScriptApiURL;
      const headers = {
        Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
          }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      setIsDownloadClicked(false);
      errorNotify("Something went wrong.");
    }
  };
  const handleDownloadScript = async (id) => {
    setIsDownloadClicked(true);
    const filename = `Scrip-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Equity Scrip"];

  const buttonConfig = {
    value: "script",
    name: "Scrip",
    getOneHandler: handleGetOneScript,
    addHandler: handleAddScript,
    editHandler: handleEditScript,
    deleteHandler: handleDeleteScript,
    downloadHandler: handleDownloadScript,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterScriptHeader
        key={renderKey}
        onFilterChange={handleFilterChange}
        tableData={data}
        filterDataByDate={filterDataByDate}
        setBankData={setBankData}
        setDateFilters={setDateFilters}
        setIsFilter={setIsFilter}
        isFilter={isFilter}
      />
      <MasterScriptTable
        tableData={globalFilters || dateFilters ? bankData : data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setIsImport={setIsImport}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Scrip")}
        setIsFilter={setIsFilter}
        isFilter={isFilter}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && (
        <MasterScriptAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterScriptEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isImport && (
        <MasterScriptImport
          setIsImport={setIsImport}
          handleImportScript={handleImportScript}
          isLoading={isLoading}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterScript;
